import React, { useState, useEffect } from 'react';
import { IonModal } from '@ionic/react';
import * as BasketStore from '../store/BasketStore';
import './MopHeaderMenusModal.scss';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { baseUrl, cacheBust } from '../helpers/configHelper';
import '../theme/common.scss';
import AgeSelect from '../components/AgeSelect';
import { ApplicationState } from '../store';

interface KidsEatFreeModalProps {
	showModal: boolean;
	closeModal: () => void;
    completeModal: () => void;
	kidsMeals: AgeRestrictedDiscount[];
}

const KefList = (props: { kidsMeals: AgeRestrictedDiscount[], index: number }) => {
	const kids = props.kidsMeals.map((_, i) => {
		if (i === props.index) {
			return <svg key={i} width="20" height="20" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="25.5" cy="25.5" r="24" fill="white" stroke="#0B9A3E" stroke-width="3" />
			</svg>
		}

		return <svg key={i} width="20" height="20" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="25.5" cy="25.5" r="25.5" fill="#D9D9D9" />
		</svg>
	});

	return (
		<ul className="flex-row space-x-4">{kids}</ul>
	);
}

const KidsEatFreeModal = (props: KidsEatFreeModalProps) => {
    const basketStore = useSelector((state: ApplicationState) => state.basket);

	const [kid, setKid] = useState(0);
	const [age, setAge] = useState<number | null>(null);
	const [error, setError] = useState("");
	const [kidsMeals, setKidsMeals] = useState<AgeRestrictedDiscount[]>(props.kidsMeals);

	const boundSetDiscountAges = bindActionCreators(BasketStore.actionCreators.setDiscountAges, useDispatch());
	const boundSetIsKefComplete = bindActionCreators(BasketStore.actionCreators.setIsKefComplete, useDispatch());
	const history = useHistory();

    useEffect(() => {
        if (basketStore?.basket?.ageRestrictedDiscounts) {
           setKidsMeals(basketStore.basket.ageRestrictedDiscounts);
        }
    }, [basketStore?.basket?.ageRestrictedDiscounts])

	const nextKid = () => {
		setKid(k => k + 1);
		setAge(null);
	}

	const handleAgeClick = (change: number) => {
		setAge(a => {
			if (a === null) {
				setError("")

				if (change < 0) {
					return 16;
				}

				return 0;
			}

			if (a + change <= 16) {
				setError("");
			}

			return clamp(a + change, 0, 100);
		});
	}

	const clamp = (value: number, min: number, max: number) => {
		return Math.min(max, Math.max(min, value));
	}

	const handleConfirmClick = () => {
		if (age === null) {
			setError("You must enter the child's age");
			return;
		}

		if (age > 16) {
			setError("The child must be 16 or under");
			return;
		}

		setError("");

		const newKidsMeals = kidsMeals.map((m, i) => {
			if (i === kid) {
				m.ageIsValid = true;
			}

			return m;
		});

		setKidsMeals(newKidsMeals);

		if (kid + 1 < props.kidsMeals.length) {
			nextKid();
			return;
		}

		completeModal();
	}

	const handleCancelClick = () => {
		setError("");

		if (kid + 1 < props.kidsMeals.length) {
			nextKid();
			return;
		}

		completeModal();
	}

	const resetState = () => {
		setKid(0);
		setAge(null);
		setError("");
		setKidsMeals(JSON.parse(JSON.stringify(props.kidsMeals)));
	}

	const completeModal = () => {
		boundSetDiscountAges(kidsMeals, () => {
			resetState();
		    boundSetIsKefComplete(true);
			props.completeModal();
		});
	}

	const exitModal = () => {
		resetState();
		props.closeModal();
	}

	return (
		<IonModal
			isOpen={props.showModal}
			swipeToClose={true}
			onDidDismiss={exitModal}
			cssClass="AppHeaderBurgerMenu kef-modal"
		>
			<img src={`${baseUrl()}/images/assets/category_header_Menu_Cafe.png?v=${cacheBust()}`} />
			<div className="content">
				<div className="space-y-4">
					<h3>{props.kidsMeals[kid]?.rewardNames}</h3>
					<p className="font-bold">
						To enjoy our kids eat free offer your child needs to be 16
						or under.
					</p>
					<p>
						Please enter your child's age and press
						<span className="font-bold"> {
							(props.kidsMeals.length === 1)
								? " 'I'm with a child who is 16 or under'"
								: ` 'Child ${kid + 1} is 16 or under'`
						}</span>
					.
					</p>
					<p>
						If you would like to enjoy our kids meal as a paid for small
						portion then please press
						<span className="font-bold">{
							" 'Add to basket at full price'"
						}</span>
					.
				</p>
				</div>

				<div className="flex-1 flex-col space-y-4 items-center">
					{props.kidsMeals.length > 1 &&
						<div>
							<KefList index={kid} kidsMeals={props.kidsMeals} />
						</div>
					}

					<h2 className={error ? "error" : ""}>{
						(props.kidsMeals.length === 1)
							? "Child's age"
							: `Child ${kid + 1}'s age`
					}</h2>

					<AgeSelect
						onChangeValue={value => handleAgeClick(value)}
						value={age}
						disableSubtract={age === null ? false : age <= 0}
						disableAdd={age === null ? false : age >= 100}
						error={error.length > 0}
					/>

					<p className={`font-bold error ${error ? "visible" : "invisible"}`}>
						{error ? error : "None"}
					</p>
				</div>
				<div className="flex-1 flex-col justify-center">
					<button className={`${error ? "error" : "confirm"}`} onClick={handleConfirmClick}>
						{
							(props.kidsMeals.length === 1)
								? "I'm with a child who is 16 or under"
								: `Child ${kid + 1} is 16 or under`
						}
					</button>
					<div className="space"></div>
					<button className="cancel" onClick={handleCancelClick}>
						{`Add to basket at full price - £${Math.abs(props.kidsMeals[kid]?.discountValue ?? 0).toFixed(2)}`}
					</button>
					<div className="space"></div>
					<p className="text-center font-bold text-xl exit" onClick={exitModal}>
						Change my order
					</p>
				</div>
			</div>
		</IonModal>
	)
}

export default KidsEatFreeModal;
